var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"btn-amount",class:{'active': _vm.isActive},on:{"click":_vm.choosePaymentAmount}},[_c('span',[_vm._v("$"+_vm._s(_vm.item.value))])])}
var staticRenderFns = []

export { render, staticRenderFns }